<template>
  <v-app>
    <v-main>
      <table-page :headers="headers" :items="unitOfMeasurements" />
    </v-main>
  </v-app>
</template>
<script>
import TablePage from "../../../components/TablePage.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    TablePage,
  },
  methods: {
    ...mapActions(["getUnitOfMeasurements"]),
  },
  created() {
    this.$store.commit("setSearchTerm", "");
    this.getUnitOfMeasurements();
  },
  computed: {
    ...mapGetters(["currentInstitution", "unitOfMeasurements"]),
  },
  data() {
    return {
      headers: [
        {
          text: "Unit Name",
          align: "start",
          value: "unitName",
        },
        { text: "Unit Symbol", value: "unitSymbol" },
        { text: "Code", value: "code" },
        { text: "Description", value: "description" },
        { text: "Created Date", value: "createdDate" },
        { text: "Created By", value: "creatorAccount" },
      ],
      items: [],
    };
  },
};
</script>
<style>
.text-start {
  font-size: 14px !important;
}
.td.text-start {
  font-size: 13px !important;
  height: 48px;
}
</style>